import { Image } from '@chakra-ui/react'

export default function PremiumTag() {
  return (
    <>
      <Image src="/video/premium.svg" alt="Premium Video" w={20} />
    </>
  )
}
